


import { usePage } from '@inertiajs/react'
import React from 'react'
import { dummyCategoryIcons } from '@/utils/dummy'
import styled from 'styled-components'

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import TransLink from '@/utils/TransLink';

import arrow from "../assets/Arrow.svg";
import forestimage from "../assets/forest.png";
import forestimagewebp from "../assets/forest.webp";
import gridimage1 from "../assets/gridimage1.png";
import gridimage1webp from "../assets/gridimage1.webp";
import gridimage2 from "../assets/gridimage2.png";
import gridimage2webp from "../assets/gridimage2.webp";
import gridimage3 from "../assets/gridimage3.jpeg";
import gridimage3webp from "../assets/gridimage3.webp";
import gridimage4 from "../assets/gridimage4.jpeg";
import gridimage4webp from "../assets/gridimage4.webp";
import laptopimage from "../assets/laptopimage.png";
import laptopimagewebp from "../assets/laptopimage.webp";
import seaimage from "../assets/sea.png";
import seaimagewebp from "../assets/sea.webp";
import nisi from "../assets/nisaki5.svg";
import WebPImage from './WebPImage';
import { useTranslation } from 'react-i18next';


type Props = {}

type CategoryIcon = {
  title: string
  url: string
  icon: string
}

type CategoriesShortcut = {
  title: string
  target: "_self" | "_blank"
  url: string
  icon_font: string
}

const CategoryIconList = () => {
  const props = usePage().props;
  const { t } = useTranslation()
  const categoriesShortcut = props.categoriesShortcut as CategoriesShortcut[] | null;

  const CategoryIcon = ({ title, url, icon_font, target }: CategoriesShortcut) => {
    return (
      <TransLink url={url} target={target === '_blank' ? '_blank' : '_self'} className='flex flex-col items-center hover:scale-105 transition-all active:scale-100'>
        <div
          className="w-[90px] h-[90px] 2xl:w-[132px] 2xl:h-[132px]  aspect-square bg-gradient-to-b from-dark-blue to-[#1E25CA] rounded-full border-2 flex items-center justify-center mb-3"
          dangerouslySetInnerHTML={{ __html: icon_font }}>
        </div>
        <label className="lg:text-lg 2xl:text-2xl font-light hover:cursor-pointer text-center">{title}</label>
      </TransLink>
    )
  }


  const SwiperSlideItem = ({
    srcWebP,
    srcFallback,
    title,
    url
  }) => {

    return (
      <SwiperSlide >
        <TransLink
          url={url}
          className="relative"
        >
          <div className="relative ">
            <WebPImage
              className="object-cover rounded-lg h-[340px] w-[316px] brightness-[60%]"
              srcWebP={srcWebP}
              srcFallback={srcFallback}
              alt="My image description"
            />
            <span className="absolute font-bold text-white m-2 text-2xl z-10 top-2 left-2">
              {title}
            </span>
          </div>
          <div className="absolute bottom-2 right-12 rounded-full">
            <img
              src={arrow}
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
        </TransLink>
      </SwiperSlide>
    )

  }

  return (

    <Swiper
      style={{ padding: 10, maxWidth: 1350 }}
      spaceBetween={20}
      slidesPerView={1.2}
      breakpoints={{
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1100: {
          slidesPerView: 4,
          spaceBetween: 18,
        }
      }}
    >
      {/* {categoriesShortcut && categoriesShortcut.map((item) => {
        const selected = dummyCategoryIcons.find((icon) => icon.id === item.icon_font)
        return (
          <SwiperSlide key={item.icon_font}>
            <CategoryIcon
              icon_font={selected?.icon ?? ''}
              title={item.title}
              url={item.url}
              target={item.target} />
          </SwiperSlide>

        )
      })} */}

      {/* <SwiperSlideItem srcFallback={gridimage1} srcWebP={gridimage1webp} url={"search?searchScope[]=Activity"} title={`${t("Activity", { ns: "glossary" })}`} /> */}

      <SwiperSlide>
        <TransLink
          url="search?searchScope[]=Activity"
          className="relative"
        >
          <div className="relative border-2 border-white rounded-lg ">
            <WebPImage
              className="object-cover rounded-lg  brightness-[60%] h-[340px] w-full"
              srcWebP={gridimage1webp}
              srcFallback={gridimage1}
              alt="My image description"
            />
            <span className="absolute font-bold text-white m-2 text-2xl z-10 top-2 left-2">
              {t("Activity", { ns: "glossary" })}
            </span>
          </div>
          <div className="absolute bottom-2 right-4 rounded-full">
            <img
              src={arrow}
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
        </TransLink>
      </SwiperSlide>

      <SwiperSlide>
        <TransLink
          url="search?searchScope[]=Place"
          className="relative"
        >
          <div className='border-2 border-white rounded-lg '>
            <span className="absolute text-white font-bold m-2 text-2xl z-10 top-2 left-2">
              {t("Place", { ns: "glossary" })}
            </span>
            <WebPImage
              className="h-[340px] w-full object-cover rounded-lg brightness-[60%]"
              srcWebP={gridimage2webp}
              srcFallback={gridimage2}
              alt="Hero"
            />
          </div>
          <div className="absolute bottom-2 right-4 rounded-full">
            <img
              src={arrow}
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
        </TransLink>
      </SwiperSlide>

      <SwiperSlide >
        <TransLink
          url="search?searchScope[]=Event"
          className="relative"
        >
          <div className='border-2 border-white rounded-lg '>
            <span className="absolute m-2 font-bold text-white text-2xl z-10 top-2 left-2">
              {t("Event", { ns: "glossary" })}
            </span>
            <WebPImage
              className="h-[340px] object-cover rounded-lg brightness-[60%]"
              srcWebP={gridimage3webp}
              srcFallback={gridimage3}
              alt="Hero"
            />
          </div>
          <div className="absolute bottom-2 right-4 rounded-full">
            <img
              src={arrow}
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
        </TransLink>
      </SwiperSlide>

      <SwiperSlide >
        <TransLink
          url="search?searchScope[]=Accomodation"
          className="relative md:col-span-2"
        >
          <div className='border-2 border-white rounded-lg '>
            <span className="absolute font-bold text-white m-2 text-2xl z-10 top-2 left-2">
              {t("Accomodation", { ns: "glossary" })}
            </span>
            <WebPImage
              className="h-[340px] object-cover rounded-lg brightness-[60%]"
              srcWebP={gridimage4webp}
              srcFallback={gridimage4}
              alt="Hero"
            />
          </div>
          <div className="absolute bottom-2 right-4 rounded-full">
            <img
              src={arrow}
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
        </TransLink>
      </SwiperSlide>

    </Swiper >

  )
}

export default CategoryIconList

const ScrollContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  gap: 2.5rem; /* gap-10 */
  margin-left: 1rem;
  margin-right: 1rem;
  overflow-x: auto;

  /* Scrollbar Styling */
  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c0c0c0;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #999;
  }

  scrollbar-width: thin;
  scrollbar-color: #c0c0c0 #f0f0f0;

  @media (min-width: 1024px) {
    margin-left: 0;
    margin-right: 0;
    overflow: visible;
  }
`;